import { getPricingString } from 'common/utils/common';
import { planHasPrice } from '../plans';
import { ShopFeatures } from '../types';
import { ProductPricing, ProductPricingDefinition } from './types';

export const getProductPricingString = (price: ProductPricing): string | null => {
	const parts = [
		!!price.fixed?.value ? `${getPricingString(price.fixed.value, price.fixed.currency)}` : null,
		!!price.commission ? `${price.commission}%` : null,
	].filter((item) => !!item);

	if (parts.length === 0) return null;

	return parts.join(' + ');
};

export const getMultipliedProductPricingString = (
	price: ProductPricing | null,
	multiplier: number,
): string | null => {
	const parts = [
		!!price?.fixed?.value
			? `${getPricingString(price.fixed.value * multiplier, price.fixed.currency)}`
			: null,
		!!price?.commission ? `${price.commission}%` : null,
	].filter((item) => !!item);

	if (parts.length === 0) return null;

	return parts.join(' + ');
};

export const hasPaidFunctionalities = (features?: ShopFeatures): boolean => {
	if (!features) return false;
	return planHasPrice(features.plan);
};

export const isFreePrice = (price?: ProductPricing | null): boolean => {
	return !price?.fixed?.value && !price?.commission;
};

export const getProductPricingFromPricingDefinition = (
	definition: ProductPricingDefinition | null,
): ProductPricing | null => {
	if (!definition) return null;
	const pricing = {
		fixed: definition?.fixed?.amount ?? null,
		commission: definition?.commission?.percentage ?? null,
	};

	return isFreePrice(pricing) ? null : pricing;
};
